import { render, staticRenderFns } from "./floorvalue.vue?vue&type=template&id=b3a80328&"
import script from "./floorvalue.vue?vue&type=script&lang=js&"
export * from "./floorvalue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3a80328')) {
      api.createRecord('b3a80328', component.options)
    } else {
      api.reload('b3a80328', component.options)
    }
    module.hot.accept("./floorvalue.vue?vue&type=template&id=b3a80328&", function () {
      api.rerender('b3a80328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2j5GmkMgYfn87/JS/comp/floorvalue.vue"
export default component.exports